import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { AuthGuard } from './helper/auth.guard';
import { LoginComponent } from './views/login/login.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
     canActivate: [AuthGuard],
    children: [
     {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
        {
        path: 'settings',
        loadChildren: () => import('./views/settings/settings.module').then(m => m.SettingsModule)
      },
        {
        path: 'packages',
        loadChildren: () => import('./views/packages/packages.module').then(m => m.PackagesModule)
      },
        {
        path: 'staff',
        loadChildren: () => import('./views/staff/staff.module').then(m => m.StaffModule)
      },
        {
        path: 'customers',
        loadChildren: () => import('./views/customers/customers.module').then(m => m.CustomersModule)
      },
        {
        path: 'leads',
        loadChildren: () => import('./views/leads/leads.module').then(m => m.LeadsModule)
      }
        ,
        {
        path: 'volunteers',
        loadChildren: () => import('./views/volunteers/volunteers.module').then(m => m.VolunteersModule)
      }
      ,
        {
        path: 'deekshe',
        loadChildren: () => import('./views/deekshe/deekshe.module').then(m => m.DeeksheModule)
      },
      {
      path: 'receipt',
      loadChildren: () => import('./views/receipts/receipts.module').then(m => m.ReceiptsModule)
    }
    ]
  },

];


@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
